// AOS.init();

Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options for a specific gallery
});

$(document).ready(function () {
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 10) {
            $('.navbar').addClass('header-fixed');
        }
        else {
            $('.navbar').removeClass('header-fixed');
        }
    });

    $(".SerachBtn").click(function () {  //use a class, since your ID gets mangled
        $('.Custom-SearchModal').addClass("active");      //add the class to the clicked element
        $('body').addClass("overflow");      //add the class to the clicked element
    });
    $(".CSM-close").click(function () {  //use a class, since your ID gets mangled
        $('.Custom-SearchModal').removeClass("active");      //add the class to the clicked element
        $('body').removeClass("overflow");      //add the class to the clicked element
    });

    // var divisor = document.getElementById("divisor"),
    //     slider = document.getElementById("slider");
    //     function moveDivisor() { 
    //         divisor.style.width = slider.value+"%";
    // }    
});

$(document).ready(function () {
    // $('.category-ImgTxtArrow').on('click', function (e) {
    $('.category-arrow').on('click', function (e) {
        e.preventDefault();
        // const $parent = $(this).parent();
        const $parent = $(this).parent().parent();
        const isActive = $parent.hasClass('active');

        // Remove 'active' from all siblings
        $parent.siblings().removeClass('active');

        // Toggle 'active' only on the clicked one
        $parent.toggleClass('active', !isActive);
    });

    // Auto expand when a sub-category is active
    let activeWrap = $(".sub-cat-active").closest('.sub_cat_listing');
    if (activeWrap.length) {
        activeWrap.addClass("active-parent").attr("style", "display:block;");  
    }
});


// banner slider js

$('.new-arrival').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: false,
    center: false,
    // navText: ['<i class="bi bi-arrow-left"></i>','<i class="bi bi-arrow-right"></i>'],
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
    autoplayTimeout: 6000,
    autoplaySpeed: 2000,
    smartSpeed: 2000,
    // animateOut: 'pulseOut',
    // animateIn: 'pulseIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        576: {
            items: 2,
        },
        767: {
            items: 3,
        },
        992: {
            items: 4.4,
        },
        1200: {
            items: 4.4,
        },
        1400: {
            items: 4.4,
        },
        1600: {
            items: 4.4,
        },
    }
});

$('.selected-slider-women').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: false,
    center: false,
    // navText: ['<i class="bi bi-arrow-left"></i>','<i class="bi bi-arrow-right"></i>'],
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
    autoplayTimeout: 6000,
    autoplaySpeed: 2000,
    smartSpeed: 2000,
    // animateOut: 'pulseOut',
    // animateIn: 'pulseIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        576: {
            items: 2,
        },
        767: {
            items: 3,
        },
        992: {
            items: 4.4,
        },
        1200: {
            items: 4.4,
        },
        1400: {
            items: 4.4,
        },
        1600: {
            items: 4.4,
        },
    }
});
$('.selected-slider-men').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: false,
    center: false,
    // navText: ['<i class="bi bi-arrow-left"></i>','<i class="bi bi-arrow-right"></i>'],
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
    autoplayTimeout: 6000,
    autoplaySpeed: 2000,
    smartSpeed: 2000,
    // animateOut: 'pulseOut',
    // animateIn: 'pulseIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        576: {
            items: 2,
        },
        767: {
            items: 3,
        },
        992: {
            items: 4.4,
        },
        1200: {
            items: 4.4,
        },
        1400: {
            items: 4.4,
        },
        1600: {
            items: 4.4,
        },
    }
});

$('.shopWSR-carousel').owlCarousel({
    loop: true,
    center: true,
    items: 3,             // number of slides visible on wide screens
    margin: 0,
    // stagePadding: 180,    // controls how much of left/right slides are visible — tweak to match design
    smartSpeed: 700,
    autoplay: false,
    autoplayTimeout: 4000,
    nav: false,
    dots: false,
    responsive: {
        0: {
            items: 1,
            stagePadding: 40
        },
        480: {
            items: 1,
            stagePadding: 60
        },
        768: {
            items: 2,
            stagePadding: 110
        },
        1000: {
            items: 3,
            stagePadding: 140
        },
        1400: {
            items: 3,
            stagePadding: 180
        }
    },
    // This ensures keyboard focus won't break the center class when clicking
    onInitialized: function () {
        // force a refresh of center class states
        $('#hero-carousel').trigger('refresh.owl.carousel');
    }
});
// $('.Brands-slider').owlCarousel({
//     loop: true,
//     margin: 15,
//     nav: false,
//     dots: false,
//     autoplay: true,
//     navText: ['<i class="fa-solid fa-chevron-left"></i>','<i class="fa-solid fa-chevron-right"></i>'],
//     autoplayTimeout: 5000,
//     autoplaySpeed: 3000,
//     smartSpeed: 2500,
//     // animateOut: 'fadeOut',
//     // animateIn: 'fadeIn',
//     autoplayHoverPause: false,
//     responsiveClass: true,
//     responsive:{
//         0:{
//             items: 1,
//         },
//         320:{
//             items: 2,
//         },
//         580:{
//             items: 3,
//         },
//         767:{
//             items: 4,
//         },
//         992:{
//             items: 5,
//         },
//         1200:{
//             items: 6,
//         },
//         1400:{
//             items: 7,
//         }
//     }
// });